// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1GyLq","dragIcon":"Choice_dragIcon__YZMNr","left":"Choice_left__1tXsO","input":"Choice_input__3ujhq"};